// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { CalendarDays as RawCalendarDays } from "lucide-react";
export const CalendarDays = /* @__PURE__ */ createIcon(RawCalendarDays, "CalendarDays", 2);
